// extracted by mini-css-extract-plugin
export default {"sensor":"VisibilitySensor_sensor__hdVOA","sensor_clickable":"VisibilitySensor_sensor_clickable__Elxy8","sensor_active":"VisibilitySensor_sensor_active__URwMf"};